import React from 'react';
import { FaRegCalendarAlt } from 'react-icons/fa';
import SharedHeader from '../../../components/SharedHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import UnderConstruction from '../../../components/UnderConstruction';
import './markalendar.css';

const MarketingCalendar = () => {
  return (
    <div className="markalendar_page">
      <SharedHeader />
      
      <div className="markalendar_container">
        <header className="markalendar_header">
          <div className="markalendar_header_icon">
            <FaRegCalendarAlt />
          </div>
          <h1>Marketing Calendar</h1>
          <p>Plan and schedule your marketing activities</p>
        </header>

        {/* Under Construction Notice */}
        <UnderConstruction pageName="Marketing Calendar" />
      </div>

      <DashboardFooter />
    </div>
  );
};

export default MarketingCalendar;
